import React, { Component } from 'react';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import DropDownTable from '../../Shared/DropDownTable';
import '../../../css/PreAdvise/UploadPreadviseDocument.css';
import Input from '../../Shared/Input';
import Button from '../../Shared/Button';
import search from '../../../Assets/TruckVisits/Assets-Desktop/search-icon.svg';
import rightarrow from '../../../Assets/ContainerStatus/Assets_Desktop/arrow-right-red.svg';
import download from '../../../Assets/TruckVisits/Assets/download.svg';
import UploadXlsxFile from '../../Shared/UploadXlsxFile';
import Loader from "react-loader";
import SuccessModal from '../../Shared/SuccessModal';
import AddProfileModal from '../../Shared/GenericModalError';
import Message from '../../../Data/Shared/Message.json';
import ColorCode from '../../../Data/Shared/ColorCode.json';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
import { Link } from 'react-router-dom';
class UploadPreadviseDocument extends Component {
    constructor(props) {
        super(props)
        this.container = React.createRef();
        this.state = {
            errors: {},
            loaderTime: false,
            PageDisable: false,
            FilePathCIPC: '',
            hasOpen: false,
            hasOpenusuccess: false,
            lineOperator: '',
            lineoperatordropdown: false,
            lineoperatordata: [{ name: "dca" }, { name: "abc" }, { name: "bcd" }],
            lineoperatordataTemporary: [],
            bookingNo: '',
        }
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.handleChangeLineOperator = this.handleChangeLineOperator.bind(this);
    }
    componentDidMount = () => {
        document.addEventListener("mousedown", this.handleClickOutside);
    }
    OnValidated = () => {
        this.setState({ hasOpen: true });
    }
    handleClickOutside = event => {
        if (this.container.current && !this.container.current.contains(event.target)) {
            this.setState({ lineoperatordropdown: false });
        }
    };
    uploadFileFunction = (uploadConfirm) => {
        document.getElementById('uploadCIPC').style.borderColor = ColorCode.colorCode.black;
    }
    setLoaderCIPC = (filePathURL) => {
        this.setState({ loaderTime: filePathURL });
        this.setState({ PageDisable: filePathURL });
    }
    setUploadLinkCIPC = (filePathURL) => {
        // for loader end
        this.setState({ FilePathCIPC: filePathURL });
        this.setState({ loaderTime: false });
        this.setState({ PageDisable: false });
        console.log("CIPC", filePathURL);
    }
    handleSubmit = () => {
        if (this.handleValidation()) {
            this.OnValidated();
        }
    }
    handleValidation() {
        let errors = {};
        let formIsValid = true;
        var fileupload = document.getElementById("upload");
        if (fileupload?.files?.length === 0) {
            formIsValid = false;
            errors["fileupload"] = Message.validation.required;
            document.getElementById('uploadCIPC').style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementById('uploadCIPC').style.borderColor = ColorCode.colorCode.black;
        }
        if (!this.state.lineOperator) {
            formIsValid = false;
            errors["lineOperator"] = Message.validation.required;
            document.getElementsByName('lineOperator')[0].style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementsByName('lineOperator')[0].style.borderColor = ColorCode.colorCode.black;
        }
        if (!this.state.bookingNo) {
            formIsValid = false;
            errors["bookingNo"] = Message.validation.required;
            document.getElementsByName('bookingNo')[0].style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementsByName('bookingNo')[0].style.borderColor = ColorCode.colorCode.black;
        }
        this.setState({ errors: errors });
        return formIsValid;
    }
    onCloseModal = () => {
        this.setState({ hasOpen: false });
        this.props.history.push('/home', {})
    };
    onCloseModalUnsuccess = () => {
        this.setState({ hasOpenusuccess: false });
        this.props.history.push('/home', {})
    };
    handleChangeBookingNo = (e) => {
        this.setState({ bookingNo: e.target.value });
        this.setState({
            errors: {
                ...this.state.errors,
                bookingNo: ''
            }
        });
        document.getElementsByName('bookingNo')[0].style.borderColor = ColorCode.colorCode.black;
    }
    handleChangeLineOperator = (e) => {
        this.setState({ lineOperator: e.target.value, searchlinelength: e?.target?.value?.length });
        this.setState({
            errors: {
                ...this.state.errors,
                lineOperator: ''
            }
        });
        document.getElementsByName('lineOperator')[0].style.borderColor = ColorCode.colorCode.black;
    }
    toggleSearchlineoperatordrop = (e) => {
        this.setState({ lineoperatordropdown: true });
    };
    changelineoperator = (event) => {
        const found = this.state.lineoperatordataTemporary?.find((name) => {
            if (name?.name === event?.target?.innerText) {
                return name
            }
        })
        this.setState({ lineOperator: found.name });
        this.setState({ lineoperatordropdown: !this.state.lineoperatordropdown });
    }
    render() {
        if (this.state.searchlinelength > 0) {
            this.state.lineoperatordataTemporary = this.state.lineoperatordata?.filter(i => i?.name?.startsWith(this.state.lineOperator?.toLowerCase()))
            console.log("line", this.state.lineoperatordataTemporary);
        } else {
            console.log("else", this.state.lineoperatordataTemporary);
            this.state.lineoperatordataTemporary = [];
        }
        return (
            <div class="caacsoutercolor">
                <MetaDecorator title={TitleDescription.uploadPreAdviseDocumentPageTitle} description={TitleDescription.uploadPreAdviseDocumentPageDescription} />
                <Loader
                    loaded={!this.state.loaderTime}
                    lines={10}
                    length={10}
                    width={8}
                    radius={10}
                    corners={1}
                    rotate={0}
                    direction={1}
                    color="#000"
                    speed={1}
                    trail={60}
                    shadow={false}
                    hwaccel={false}
                    className="spinner"
                    zIndex={2e9}
                    top="50%"
                    left="50%"
                    scale={1.0}
                    loadedClassName="loadedContent"
                />
                <Header tilesFetched={() => { }} />
                <div class="caacsnofullprepro">
                    <div id="caacsnobox1preup">
                        <nav class="caacnononavbar">
                            <div className="arcaacnonavbarname">
                                <small id="nonavc">Pre-advise for Multiple Containers</small>
                            </div>
                        </nav>
                        <hr class="hr1" />
                        <div class="arcaanotificationmaincardprepro">
                            <div class="caaoncsdivlow1preex">
                                <div class="csdivlow2">
                                    Upload Pre-advise Proxy Document
                                </div>
                            </div>
                            <div class="preprodiv" >
                                <div class="preprodivin">
                                    <div class="caadivup55">
                                        <div class="caadivup3" id="desktopuperdiv">
                                            <small id="caaname">Line Operator</small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    name="lineOperator"
                                                    class="input" placeholder="Enter Line Operator"
                                                    type="text" id="caad06" value={this.state.lineOperator}
                                                    onChange={this.handleChangeLineOperator}
                                                    onKeyPress={this.toggleSearchlineoperatordrop}
                                                />
                                                <div className="createpreadviseerror11proxy">{this.state.errors["lineOperator"]}</div>
                                                <img id="caasinput_imgAddProfile" src={search}></img>
                                            </div>
                                            {this.state.lineoperatordropdown && (
                                                <div class="caaad08" >
                                                    <div class="caadropdowncard" ref={this.container} >
                                                        {(this.state.lineoperatordataTemporary?.map((name, index) => {
                                                            return (
                                                                <DropDownTable onClick={(index1) => this.changelineoperator(index1)}>
                                                                    <small class="pl-3" id="caatt2" >{name?.name} </small>
                                                                </DropDownTable>
                                                            );
                                                        }))}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                        <div class="caadivup3mobile" id="mobileuperdiv">
                                            <small id="caaname">Line Operator</small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    name="lineOperator"
                                                    class="input" placeholder="Enter Line Operator"
                                                    type="text" id="caad06" value={this.state.lineOperator}
                                                    onChange={this.handleChangeLineOperator}
                                                    onKeyPress={this.toggleSearchlineoperatordrop}
                                                />
                                                <div className="createpreadviseerror11proxy">{this.state.errors["lineOperator"]}</div>
                                                <img id="caasinput_imgAddProfile" src={search}></img>
                                            </div>
                                            {this.state.lineoperatordropdown && (
                                                <div class="caaad08" >
                                                    <div class="caadropdowncard" ref={this.container} >
                                                        {(this.state.lineoperatordataTemporary?.map((name, index) => {
                                                            return (
                                                                <DropDownTable onClick={(index1) => this.changelineoperator(index1)}>
                                                                    <small class="pl-3" id="caatt2" >{name?.name} </small>
                                                                </DropDownTable>
                                                            );
                                                        }))}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                        <div class="caadivup3proxy" id="desktopuperdiv">
                                            <small id="caaname">Booking No.</small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    name="bookingNo"
                                                    class="input" placeholder="Enter Booking No."
                                                    type="text" id="caad06" value={this.state.bookingNo}
                                                    onChange={this.handleChangeBookingNo}
                                                />
                                                <div className="createpreadviseerror11">{this.state.errors["bookingNo"]}</div>
                                            </div>
                                        </div>
                                        <div class="caadivup3" id="mobileuperdiv">
                                            <div class="proxydivupd">
                                                <div class="proxydivinupd">
                                                    <small class="proxydivtext">Only those shipping lines will be visible for which proxy is approved by admin. You can submit your proxy </small>
                                                    <small class="proxydivtextred"> here</small>
                                                    <img
                                                        src={rightarrow}
                                                        class="" id="proxytextimgred"
                                                        alt="" loading="lazy"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="proxycaadivup5upupd">
                                        <div class="caadivup3" id="desktopuperdiv">
                                            <div class="proxydivupd">
                                                <div class="proxydivinupd">
                                                    <small class="proxydivtext">Only those shipping lines will be visible for which proxy is approved by admin. You can submit your proxy </small>
                                                    <small class="proxydivtextred"> here</small>
                                                    <img
                                                        src={rightarrow}
                                                        class="" id="proxytextimgred"
                                                        alt="" loading="lazy"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="caadivup3proxy" id="mobileuperdiv">
                                            <small id="caaname">Booking No.</small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    name="bookingNo"
                                                    class="input" placeholder="Enter Booking No."
                                                    type="text" id="caad06" value={this.state.bookingNo}
                                                    onChange={this.handleChangeBookingNo}
                                                />
                                                <div className="createpreadviseerror11">{this.state.errors["bookingNo"]}</div>
                                            </div>
                                        </div>
                                        <div class="caadivup3upload">
                                            <small id="caaname">Upload Excel for Bulk Pre-advise</small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <UploadXlsxFile uploaddivid="uploadCIPC" idupload="upload"
                                                    name="fileupload"
                                                    setUploadConfirm={this.uploadFileFunction}
                                                    upload_link="cipcUpload" uploadicon="cipcIcon"
                                                    setFileLink={this.setUploadLinkCIPC}
                                                    setLoader={this.setLoaderCIPC}
                                                />
                                                <div className="error1">{this.state.errors["fileupload"]}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="preprodivlow">
                                <div class="preprodivinlow">
                                    <small class="prelowtext">Please use only this excel template for bulk pre-advise</small>
                                    <div id="downloadimgdoc">
                                        <Link to={""} download>
                                            <img
                                                src={download}
                                                class="ml-3 mb-1" id=""
                                                alt="" loading="lazy"
                                            />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            <div class="caabuttdivarz">
                                <Button class="caabuttdiv1" onClick={this.handleSubmit}>
                                    <small class="caabuttdiv2">Submit</small>
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
                <SuccessModal hasOpen={this.state.hasOpen} onCloseModal={this.onCloseModal}>
                    <div>
                        <div class="successtext1outercreatepreadvise">
                            <small class="successtext1createpreadvise">Your request for bulk Pre-advise </small>
                            <small class="successtext1createpreadvise"> has been processed successfully</small>
                        </div>
                    </div>
                </SuccessModal>
                {this.state.hasOpenusuccess ? <AddProfileModal hasOpen={this.state.hasOpenusuccess} onCloseModal={this.onCloseModalUnsuccess} >
                    <div>
                        <div class="successtext1outercreatepreadvise">
                            <small class="successtext1createpreadviseupload">Your request for bulk Pre-advise has been </small>
                            <small class="successtext1createpreadvise">  processed successfully with errors</small>
                        </div>
                    </div>
                </AddProfileModal> : null}
                <div class="caanotifooter01ahzpreexp">
                    <Footer />
                </div>
                <div class="caanotifooter02ahzpreexp">
                    <Footer2 />
                </div>
            </div>
        );
    }
}
export default UploadPreadviseDocument;